import React, { useState, useEffect } from 'react'
import { Spin, Button } from 'antd'
import { useDispatch } from 'react-redux'
import CoreEnums from './core/utils/enums'
import coreReducer from './core/utils/reducer'
import EditPatientProfile from './custom/Admin/system-users/components/patient/EditPatient'
import { readSystemUsersAggregate } from './custom/Admin/system-users/utils/utils'

// Auth
import AuthReducer from './custom/Auth/utils/reducer'

// Home
import DashboardWrapper from './custom/Admin/dashboard/components/DashboardWrapper'

// Entities
import EntityWrapper from './custom/Admin/entities/components/entities-wrapper'

// Admin
import Clinics from './custom/Admin/clinics/components/ClinicsWrapper'
import ClinicsReducer from './custom/Admin/clinics/utils/reducer'
import MedicalProfessionalReducer from './custom/Admin/medical-professionals/utils/reducer'

// Patient
import PatientsReducer from './custom/Admin/patients/utils/reducer'
import PatientFileLanding from './custom/Patient/Desktop/components/PatientFileLanding'

//Services
import Services from './custom/Admin/services/components/ServicesWrapper'
import ServicesReducer from './custom/Admin/services/utils/reducer'

// System Users
import SystemUsers from './custom/Admin/system-users/components/SystemUsersContainer'
import SystemUsersReducer from './custom/Admin/system-users/utils/reducer'

// User
import Profile from './custom/Profile/components/Profile'

// Medical History
import PatMedHist from './custom/Patient/Medical History/index'
import DesktopMedicalHistoryWrapper from './custom/Patient/Medical History/desktop/components/DesktopMedicalHistoryWrapper'

import BookingsWrapper from './custom/Bookings/components/AppointmentListViewWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBarChart,
  faBook,
  faBookMedical,
  faCalendar,
  faClinicMedical,
  faCogs,
  faCreditCard,
  faDashboard,
  faDatabase,
  faFaceSmile,
  faGear,
  faHeartPulse,
  faKitMedical,
  faList,
  faMoneyBillAlt,
  faMoneyBills,
  faMortarBoard,
  faNewspaper,
  faPrescriptionBottleMedical,
  faUser,
  faUserDoctor,
  faUserGear,
  faUserGroup,
  faUsers,
  faCutlery,
  faGlobe,
  faFlask,
  faChartLine,
  faUserClock
} from '@fortawesome/free-solid-svg-icons'

// Terms and Conditions
import TermsConditionsWrapper from './custom/Admin/terms-conditions/components/terms-conditions-wrapper'

// Availability
// import Availability from './custom/Bookings/availability/components/availability'

// Config
import Config from './custom/Admin/config/components'
import PatientExaminationForm from './custom/Bookings/components/ExaminationWrapper'

// Bookings
import BookingsReducer from './custom/Bookings/utils/booking-reducer'
import AdminBookingsReducer from './custom/Admin/bookings/utils/reducer'
import BookingsListView from './custom/Admin/bookings/components/bookings-wrapper'
import Dependants from './custom/Profile/components/dependants/dependants-list-view'
import AvailabilityWrapper from './custom/Availability/components/availability-wrapper'

import {
  BarChartOutlined,
  BuildFilled,
  CalendarFilled,
  CalendarOutlined,
  FileAddOutlined,
  HomeOutlined,
  LineChartOutlined,
  MedicineBoxOutlined,
  ScheduleOutlined,
  TeamOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons'

import TodaysPatientsReducer from './custom/Dashboard/Employee/components/todays-patients/todays-patients-reducer'
import NewBooking from './custom/Bookings/components/AvailabilitySearchWrapper'

import EmployeeBookingsReducer from './custom/Bookings/utils/employee-bookings-reducer'
import BillingReducer from './custom/Bookings/utils/billing-reducer'
import DependentsReducer from './custom/Profile/components/dependants/utils/depentdents-reducer'

import EntitiesReducer from './custom/Admin/entities/utils/reducer'
import VirtualServicesWrapper from './custom/Admin/virutal-services/components/virtual-services-wrapper'
import virtualServicesReducer from './custom/Admin/virutal-services/utils/reducer'
import HealthTrackingEntriesView from './custom/Health-Tracking/entries/components/list-view'
import SubscriptionsReducer from './custom/Subscriptions/utils/reducer'
import SubscriptionsList from './custom/Subscriptions/components/subscriptions-list'
// import VitalLink from './custom/Vital-Link/components/vital-link'
import ScriptsWrapper from './custom/Scripting/components/scripting-wrapper'
import AdminSubscriptionsList from './custom/Admin-Subscriptions/components/admin-subscriptions-list'
import AdminSubscriptionsReducer from './custom/Admin-Subscriptions/utils/reducer'
import AppointmentsCalendarReducer from './custom/Appointments-Calendar/utils/appointments-calendar-reducer'
import FullCalendarWrapper from './custom/Appointments-Calendar/full-calendar-wrapper'
import ProfileEnums from './custom/Profile/utils/enums'
import AIWrapper from './custom/Ai Macro Tracker/AIMacroTrackerWrapper'
import DataPointsWrapper from './custom/Super-Admin/Data Points/data-points-wrapper'
import ClinicalReportingTemplatesWrapper from './custom/Super-Admin/Clinical Report Templates/clinical-reports-templates-wrapper'
import ClinicalAnalytics from './custom/Clinical-Analytics/components.js/clinical_analytics'
import { CarePlansWrapper } from './custom/Health Plans/Chronic Care Plans'
import { DataPointsReducer, ExamTemplatesReducer } from './custom/Examination/components/Assessment/reducers/reducers'
import patMedHistReducer from './custom/Patient/Medical History/utils/reducer'
import MobVirtualBookingWrapper from './custom/Patient/Virtual Consultation/Mobile/components/MobVirtualBookingWrapper'
import patHealthStatsReducer from './custom/Patient/Health Stats/utils/reducer'
import patAppointmentsReducer from './custom/Patient/Appointments/utils/reducer'
import PeachPaymentsWrapper from './custom/PeachPayments'
import patMacroTrackerReducer from './custom/Patient/AI Tools/Meal Tracker/Components/Mobile/utils/reducer'
import CareSyncLabTestsListView from './custom/Super-Admin/CareSync/LabTests/components/ListView'
import {
  careSyncDataPointsReducer,
  careSyncTestResultsReducer,
  careSyncTestsReducer
} from './custom/Patient/CareSync/utils/reducers'
import availabilityReducer from './custom/Availability/utils/reducer'
import InvoicesList from './custom/Invoices/components/Invoicing/InvoicesList'
import MedicalAidPaymentList from './custom/Invoices/components/medical-aid-payment-list'
import BillingDashboard from './custom/Invoices/components/Billing Dashboard'
import BillingProfile from './custom/Admin/billing-profile/components/billing-profile'
import BillingModuleEnhanced from './custom/Billing-Module-Enhanced'
import { TreatmentPlansWrapper } from './custom/Health Plans/TreatmentPlans'
import { PreventivePlansWrapper } from './custom/Health Plans/PreventivePlans'
import { RehabilitationPlansWrapper } from './custom/Health Plans/RehabilitationPlans'
import { WellnessPlansWrapper } from './custom/Health Plans/WellnessPlans'
import MealPlansWrapper from './custom/Health Plans/Meal Plans/components/MealPlansWrapper'
import { InventoryDashboard, InventoryList, PurchaseOrders, InventoryReports } from './custom/Inventory Management'
import {
  HospitalDashboard,
  Admissions,
  BedManagement,
  PatientCareTasks,
  CaregiverActivities,
  StaffReminders,
  TheatreDashboard,
  DischargeInstructions,
  SurgeryList,
  TheatreRoomEvents
} from './custom/Hospital Managment'
import PatCareSync from './custom/Patient/CareSync'
import MobHealthStatsWrapper from './custom/Patient/Health Stats/Mobile/Components/MobHealthStatsWrapper'
import PatProfile from './custom/Patient/Profile'
import { ProceduresProvider } from './custom/Examination/examination-utils/ProceduresContext'
import GlobalServicesWrapper from './custom/Super-Admin/Global Services'
import SearchEngine from './custom/Search Engine'
import searchEngineReducer from './custom/Search Engine/utils/searchReducer'
import searchEngineBookingReducer from './custom/Search Engine/utils/bookingReducer'
import LabOrdersWrapper from './custom/Lab orders/components/LabOrdersWrapper'
import SearchEngineWithProviders from './custom/Search Engine'

export const leftMenuItems = () => {
  return [
    {
      key: CoreEnums.tabKeys.HOME,
      label: CoreEnums.tabTitles.HOME,
      icon: <HomeOutlined style={{ color: CoreEnums.menuColors.HOME }} />,
      visibleTo: [
        CoreEnums.userRoles.PATIENT,
        CoreEnums.userRoles.MEDICAL_PROFESSIONAL,
        CoreEnums.userRoles.RECEPTION,
        CoreEnums.userRoles.ADMIN,
        CoreEnums.userRoles.SUBSCRIPTION_ADMIN
      ]
    },
    {
      key: CoreEnums.tabKeys.PATIENT_BILLING,
      label: CoreEnums.tabTitles.PATIENT_BILLING,
      icon: <FontAwesomeIcon icon={faMoneyBills} style={{ color: CoreEnums.menuColors.CLINICAL_ANALYTICS }} />,
      visibleTo: [CoreEnums.userRoles.RECEPTION, CoreEnums.userRoles.MEDICAL_PROFESSIONAL],
      children: [
        {
          key: CoreEnums.tabKeys.DASHBOARD_BILLING,
          label: CoreEnums.tabTitles.DASHBOARD_BILLING,
          icon: <FontAwesomeIcon icon={faDashboard} style={{ color: CoreEnums.menuColors.BILLING }} />,
          visibleTo: [CoreEnums.userRoles.RECEPTION, CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        },
        {
          key: CoreEnums.tabKeys.INVOICES,
          label: CoreEnums.tabTitles.INVOICES,
          icon: <FontAwesomeIcon icon={faMoneyBills} style={{ color: CoreEnums.menuColors.BILLING }} />,
          visibleTo: [CoreEnums.userRoles.RECEPTION, CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        },
        {
          key: CoreEnums.tabKeys.REMITTANCES,
          label: CoreEnums.tabTitles.REMITTANCES,
          icon: <FontAwesomeIcon icon={faMoneyBillAlt} style={{ color: CoreEnums.menuColors.BILLING }} />,
          visibleTo: [CoreEnums.userRoles.RECEPTION, CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        },
        {
          key: CoreEnums.tabKeys.PATIENT_ACCOUNTS,
          label: CoreEnums.tabTitles.PATIENT_ACCOUNTS,
          icon: <FontAwesomeIcon icon={faUserClock} style={{ color: CoreEnums.menuColors.PATIENT_ACCOUNTS }} />,
          visibleTo: [CoreEnums.userRoles.RECEPTION, CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        }
      ]
    },
    {
      key: CoreEnums.tabKeys.CLINICAL_ANALYTICS,
      label: CoreEnums.tabTitles.CLINICAL_ANALYTICS,
      icon: <BarChartOutlined style={{ color: CoreEnums.menuColors.SUBSCRIPTIONS }} />,
      visibleTo: [CoreEnums.userProfessions.DOCTOR, CoreEnums.userRoles.ADMIN]
    },
    {
      key: CoreEnums.tabKeys.APPOINTMENTS_CALENDAR,
      label: CoreEnums.tabTitles.APPOINTMENTS_CALENDAR,
      icon: <ScheduleOutlined style={{ color: CoreEnums.menuColors.APPOINTMENTS_CALENDAR }} />,
      visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL, CoreEnums.userRoles.RECEPTION, CoreEnums.userRoles.ADMIN]
    },
    {
      key: CoreEnums.tabKeys.MY_BOOKINGS,
      label: CoreEnums.tabTitles.MY_BOOKINGS,
      icon: <CalendarOutlined style={{ color: CoreEnums.menuColors.MY_BOOKINGS }} />,
      visibleTo: [CoreEnums.userRoles.PATIENT, CoreEnums.userRoles.MEDICAL_PROFESSIONAL, CoreEnums.userRoles.RECEPTION]
    },
    {
      key: CoreEnums.tabKeys.AVAILABILITY,
      label: CoreEnums.tabTitles.AVAILABILITY,
      icon: <CalendarFilled style={{ color: CoreEnums.menuColors.AVAILABILITY }} />,
      visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL],
      additionalValidatiors: [ProfileEnums.profileValidators.hasAvailabilityAccess]
    },
    // {
    //   key: 'inventory_management',
    //   label: 'Inventory Management',
    //   icon: <FontAwesomeIcon icon={faBoxes} style={{ color: CoreEnums.menuColors.INVENTORY_MANAGEMENT }} />,
    //   visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL],
    //   children: [
    //     {
    //       key: 'inventory_dashboard',
    //       label: 'Dashboard',
    //       icon: <FontAwesomeIcon icon={faDashboard} style={{ color: CoreEnums.menuColors.INVENTORY_DASHBOARD }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'inventory_items',
    //       label: 'Inventory Items',
    //       icon: <FontAwesomeIcon icon={faList} style={{ color: CoreEnums.menuColors.INVENTORY_ITEMS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'purchase_orders',
    //       label: 'Purchase Orders',
    //       icon: <FontAwesomeIcon icon={faMoneyBills} style={{ color: CoreEnums.menuColors.PURCHASE_ORDERS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'inventory_reports',
    //       label: 'Reports & Analytics',
    //       icon: <FontAwesomeIcon icon={faBarChart} style={{ color: CoreEnums.menuColors.INVENTORY_REPORTS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     }
    //   ]
    // },
    // {
    //   key: 'hospital_management',
    //   label: 'Hospital Management',
    //   icon: <FontAwesomeIcon icon={faClinicMedical} style={{ color: CoreEnums.menuColors.HOSPITAL_MANAGEMENT }} />,
    //   visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL],
    //   children: [
    //     {
    //       key: 'hospital_dashboard',
    //       label: 'Dashboard',
    //       icon: <FontAwesomeIcon icon={faDashboard} style={{ color: CoreEnums.menuColors.HOSPITAL_DASHBOARD }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'admissions',
    //       label: 'Admissions',
    //       icon: <FontAwesomeIcon icon={faWheelchair} style={{ color: CoreEnums.menuColors.ADMISSIONS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'bed_management',
    //       label: 'Bed Management',
    //       icon: <FontAwesomeIcon icon={faKitMedical} style={{ color: CoreEnums.menuColors.BED_MANAGEMENT }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'patient_care_tasks',
    //       label: 'Patient Care Tasks',
    //       icon: <FontAwesomeIcon icon={faList} style={{ color: CoreEnums.menuColors.PATIENT_CARE_TASKS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'caregiver_activities',
    //       label: 'Caregiver Activities',
    //       icon: <FontAwesomeIcon icon={faUserDoctor} style={{ color: CoreEnums.menuColors.CAREGIVER_ACTIVITIES }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'staff_reminders',
    //       label: 'Staff Reminders',
    //       icon: <FontAwesomeIcon icon={faCalendar} style={{ color: CoreEnums.menuColors.STAFF_REMINDERS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'theatre_dashboard',
    //       label: 'Theatre Dashboard',
    //       icon: <FontAwesomeIcon icon={faHeartPulse} style={{ color: CoreEnums.menuColors.THEATRE_DASHBOARD }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'discharge_instructions',
    //       label: 'Discharge Instructions',
    //       icon: <FontAwesomeIcon icon={faFileText} style={{ color: CoreEnums.menuColors.DISCHARGE_INSTRUCTIONS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'surgery_list',
    //       label: 'Surgery List',
    //       icon: <FontAwesomeIcon icon={faList} style={{ color: CoreEnums.menuColors.SURGERY_LIST }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     },
    //     {
    //       key: 'theatre_room_events',
    //       label: 'Theatre Room Events',
    //       icon: <FontAwesomeIcon icon={faNewspaper} style={{ color: CoreEnums.menuColors.THEATRE_ROOM_EVENTS }} />,
    //       visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    //     }
    //   ]
    // },
    {
      key: CoreEnums.tabKeys.MY_HEALTH,
      label: CoreEnums.tabTitles.MY_HEALTH,
      icon: <BarChartOutlined style={{ color: CoreEnums.menuColors.MY_HEALTH }} />,
      visibleTo: [CoreEnums.userRoles.PATIENT],
      children: [
        {
          key: CoreEnums.tabKeys.ANALYTICS,
          label: CoreEnums.tabTitles.ANALYTICS,
          icon: <FontAwesomeIcon icon={faBarChart} style={{ color: CoreEnums.menuColors.ANALYTICS }} />,
          visibleTo: [CoreEnums.userRoles.PATIENT]
        }
      ]
    },

    // Temporarily commenting out old medical history to avoid conflicts
    // {
    //   key: CoreEnums.tabKeys.MEDICAL_HISTORY,
    //   label: CoreEnums.tabTitles.MEDICAL_HISTORY,
    //   icon: <FileAddOutlined style={{ color: CoreEnums.menuColors.MEDICAL_HISTORY }} />,
    //   visibleTo: [CoreEnums.userRoles.PATIENT]
    // },
    {
      key: CoreEnums.tabKeys.NEW_MEDICAL_HISTORY,
      label: CoreEnums.tabTitles.NEW_MEDICAL_HISTORY,
      icon: <MedicineBoxOutlined style={{ color: CoreEnums.menuColors.NEW_MEDICAL_HISTORY }} />,
      visibleTo: [CoreEnums.userRoles.PATIENT]
    },
    {
      key: CoreEnums.tabKeys.MY_PATIENT_FILE,
      label: CoreEnums.tabTitles.MY_PATIENT_FILE,
      icon: <FontAwesomeIcon icon={faUser} style={{ color: CoreEnums.menuColors.MY_PATIENT_FILE }} />,
      visibleTo: [CoreEnums.userRoles.PATIENT]
    },

    {
      key: CoreEnums.tabKeys.HEALTH_TRACKING_ENTRIES,
      label: CoreEnums.tabTitles.HEALTH_TRACKING_ENTRIES,
      icon: <LineChartOutlined style={{ color: CoreEnums.menuColors.HEALTH_TRACKING_ENTRIES }} />,
      visibleTo: []
    },
    {
      key: CoreEnums.tabKeys.VITAL_LINK,
      label: CoreEnums.tabTitles.VITAL_LINK,
      new: true,
      icon: <FontAwesomeIcon icon={faHeartPulse} style={{ color: CoreEnums.menuColors.VITAL_LINK }} />,
      visibleTo: [CoreEnums.userRoles.PATIENT],
      propInEntity: CoreEnums.tabKeys.VITAL_LINK,
      enabledProp: 'enabled'
    },
    {
      key: CoreEnums.tabKeys.AIMealTracker,
      label: CoreEnums.tabTitles.AIMealTracker,
      icon: <FontAwesomeIcon icon={faCutlery} style={{ color: CoreEnums.menuColors.AIMealTracker }} />,
      visibleTo: []
    },
    {
      key: CoreEnums.tabKeys.ADMIN_SUBSCRIPTIONS,
      label: CoreEnums.tabTitles.ADMIN_SUBSCRIPTIONS,
      icon: <FontAwesomeIcon icon={faCreditCard} style={{ color: CoreEnums.menuColors.ADMIN_SUBSCRIPTIONS }} />,
      visibleTo: [CoreEnums.userRoles.SUBSCRIPTION_ADMIN]
    },
    {
      key: CoreEnums.tabKeys.CLINIC_MANAGEMENT,
      label: <span id='clinic_management_category'>{CoreEnums.tabTitles.CLINIC_MANAGEMENT}</span>,
      icon: <FontAwesomeIcon icon={faClinicMedical} style={{ color: CoreEnums.menuColors.CLINIC_MANAGEMENT }} />,
      visibleTo: [CoreEnums.userRoles.ADMIN],
      children: [
        {
          key: CoreEnums.tabKeys.CLINICS,
          label: <span id='clinics_menu_item'>{CoreEnums.tabTitles.CLINICS}</span>,
          icon: <FontAwesomeIcon icon={faClinicMedical} style={{ color: CoreEnums.menuColors.CLINICS }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN]
        },
        {
          key: CoreEnums.tabKeys.BILLING_PROFILE,
          label: <span id='billing_profile_menu_item'>{CoreEnums.tabTitles.BILLING_PROFILE}</span>,
          icon: <FontAwesomeIcon icon={faBookMedical} style={{ color: CoreEnums.menuColors.BILLING_PROFILE }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN]
        },
        {
          key: CoreEnums.tabKeys.SERVICES,
          label: <span id='services_menu_item'>{CoreEnums.tabTitles.SERVICES}</span>,
          icon: <FontAwesomeIcon icon={faList} style={{ color: CoreEnums.menuColors.SERVICES }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN]
        },
        {
          key: CoreEnums.tabKeys.AVAILABILITY,
          label: CoreEnums.tabTitles.AVAILABILITY,
          icon: <FontAwesomeIcon icon={faCalendar} style={{ color: CoreEnums.menuColors.AVAILABILITY }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN]
        },
        {
          key: CoreEnums.tabKeys.MY_BOOKINGS,
          label: CoreEnums.tabTitles.MY_BOOKINGS,
          icon: <FontAwesomeIcon icon={faBook} style={{ color: CoreEnums.menuColors.BOOKINGS }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN]
        }
      ]
    },
    {
      key: CoreEnums.tabKeys.USER_MANAGEMENT,
      label: <span id='user_management_category'>{CoreEnums.tabTitles.USER_MANAGEMENT}</span>,
      icon: <FontAwesomeIcon icon={faUsers} style={{ color: CoreEnums.menuColors.USER_MANAGEMENT }} />,
      visibleTo: [CoreEnums.userRoles.ADMIN, CoreEnums.userRoles.SUPERADMIN],
      children: [
        {
          key: CoreEnums.tabKeys.SYSTEM_USERS,
          label: <span id='system_users_menu_item'>{CoreEnums.tabTitles.SYSTEM_USERS}</span>,
          icon: <FontAwesomeIcon icon={faUsers} style={{ color: CoreEnums.menuColors.SYSTEM_USERS }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN, CoreEnums.userRoles.SUPERADMIN]
        },
        {
          key: CoreEnums.tabKeys.MEDICAL_PROFESSIONALS,
          label: <span id='medical_professionals_menu_item'>{CoreEnums.tabTitles.MEDICAL_PROFESSIONALS}</span>,
          icon: <FontAwesomeIcon icon={faUserDoctor} style={{ color: CoreEnums.menuColors.MEDICAL_PROFESSIONALS }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN, CoreEnums.userRoles.SUPERADMIN]
        },
        {
          key: CoreEnums.tabKeys.PATIENTS,
          label: <span id='patients_menu_item'>{CoreEnums.tabTitles.PATIENTS}</span>,
          icon: <TeamOutlined style={{ color: CoreEnums.menuColors.PATIENTS }} />,
          visibleTo: [
            CoreEnums.userRoles.ADMIN,
            CoreEnums.userRoles.RECEPTION,
            CoreEnums.userRoles.MEDICAL_PROFESSIONAL,
            CoreEnums.userRoles.SUPERADMIN
          ]
        }
      ]
    },
    {
      key: CoreEnums.tabKeys.PATIENTS,
      label: CoreEnums.tabTitles.PATIENTS,
      icon: <TeamOutlined style={{ color: CoreEnums.menuColors.PATIENTS }} />,
      visibleTo: [CoreEnums.userRoles.RECEPTION, CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    },
    {
      key: CoreEnums.tabKeys.SCRIPTING,
      label: CoreEnums.tabTitles.SCRIPTING,
      icon: <FontAwesomeIcon icon={faPrescriptionBottleMedical} style={{ color: CoreEnums.menuColors.SCRIPTING }} />,
      visibleTo: [CoreEnums.userProfessions.DOCTOR]
    },
    {
      key: CoreEnums.tabKeys.LAB_ORDERS,
      label: CoreEnums.tabTitles.LAB_ORDERS,
      icon: <FontAwesomeIcon icon={faFlask} style={{ color: CoreEnums.menuColors.LAB_ORDERS }} />,
      visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL, CoreEnums.userRoles.RECEPTION]
    },
    {
      key: CoreEnums.tabKeys.ENTITIES,
      label: CoreEnums.tabTitles.ENTITIES,
      icon: <BuildFilled style={{ color: CoreEnums.menuColors.ENTITIES }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.VIRTUAL_SERVICES,
      label: CoreEnums.tabTitles.VIRTUAL_SERVICES,
      icon: <FontAwesomeIcon icon={faList} style={{ color: CoreEnums.menuColors.VIRTUAL_SERVICES }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.SETTINGS,
      label: CoreEnums.tabTitles.SETTINGS,
      icon: <FontAwesomeIcon icon={faCogs} style={{ color: CoreEnums.menuColors.SETTINGS }} />,
      visibleTo: [CoreEnums.userRoles.ADMIN],
      children: [
        {
          key: CoreEnums.tabKeys.CONFIG,
          label: CoreEnums.tabTitles.CONFIG,
          icon: <FontAwesomeIcon icon={faGear} style={{ color: CoreEnums.menuColors.CONFIG }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN]
        },
        {
          key: CoreEnums.tabKeys.TERMS_AND_CONDITIONS,
          label: CoreEnums.tabTitles.TERMS_AND_CONDITIONS,
          icon: <FontAwesomeIcon icon={faNewspaper} style={{ color: CoreEnums.menuColors.TERMS_AND_CONDITIONS }} />,
          visibleTo: [CoreEnums.userRoles.ADMIN]
        }
      ]
    },
    // CRM removed
    {
      key: CoreEnums.tabKeys.DATA_POINTS_STANDARD,
      label: CoreEnums.tabTitles.DATA_POINTS_STANDARD,
      icon: <FontAwesomeIcon icon={faDatabase} style={{ color: CoreEnums.menuColors.DATA_POINTS_STANDARD }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.DATA_POINTS_GENERAL,
      label: CoreEnums.tabTitles.DATA_POINTS_GENERAL,
      icon: <FontAwesomeIcon icon={faDatabase} style={{ color: CoreEnums.menuColors.DATA_POINTS_GENERAL }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.DATA_POINTS_VITALS,
      label: CoreEnums.tabTitles.DATA_POINTS_VITALS,
      icon: <FontAwesomeIcon icon={faDatabase} style={{ color: CoreEnums.menuColors.DATA_POINTS_VITALS }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.DATA_POINTS_RAPID,
      label: CoreEnums.tabTitles.DATA_POINTS_RAPID,
      icon: <FontAwesomeIcon icon={faDatabase} style={{ color: CoreEnums.menuColors.DATA_POINTS_RAPID }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.DATA_POINTS_POC,
      label: CoreEnums.tabTitles.DATA_POINTS_POC,
      icon: <FontAwesomeIcon icon={faDatabase} style={{ color: CoreEnums.menuColors.DATA_POINTS_POC }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.DATA_POINTS_LAB,
      label: CoreEnums.tabTitles.DATA_POINTS_LAB,
      icon: <FontAwesomeIcon icon={faDatabase} style={{ color: CoreEnums.menuColors.DATA_POINTS_LAB }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: CoreEnums.tabKeys.HEALTH_PLANS,
      label: CoreEnums.tabTitles.HEALTH_PLANS,
      icon: <FontAwesomeIcon icon={faHeartPulse} style={{ color: CoreEnums.menuColors.CARE_PLANS }} />,
      visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL],
      children: [
        {
          key: CoreEnums.tabKeys.CARE_PLANS,
          label: CoreEnums.tabTitles.CARE_PLANS,
          icon: <FontAwesomeIcon icon={faKitMedical} style={{ color: CoreEnums.menuColors.CARE_PLANS }} />,
          visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        }
        // {
        //   key: CoreEnums.tabKeys.TREATMENT_PLANS,
        //   label: CoreEnums.tabTitles.TREATMENT_PLANS,
        //   icon: (
        //     <FontAwesomeIcon icon={faPrescriptionBottleMedical} style={{ color: CoreEnums.menuColors.CARE_PLANS }} />
        //   ),
        //   visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        // },
        // {
        //   key: CoreEnums.tabKeys.PREVENTATIVE_PLANS,
        //   label: CoreEnums.tabTitles.PREVENTATIVE_PLANS,
        //   icon: <FontAwesomeIcon icon={faShieldVirus} style={{ color: CoreEnums.menuColors.CARE_PLANS }} />,
        //   visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        // },
        // {
        //   key: CoreEnums.tabKeys.REHABILITATION_PLANS,
        //   label: CoreEnums.tabTitles.REHABILITATION_PLANS,
        //   icon: <FontAwesomeIcon icon={faWheelchair} style={{ color: CoreEnums.menuColors.CARE_PLANS }} />,
        //   visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        // },
        // {
        //   key: CoreEnums.tabKeys.WELLNESS_PLANS,
        //   label: CoreEnums.tabTitles.WELLNESS_PLANS,
        //   icon: <FontAwesomeIcon icon={faDumbbell} style={{ color: CoreEnums.menuColors.CARE_PLANS }} />,
        //   visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        // },
        // {
        //   key: CoreEnums.tabKeys.MEAL_PLANS,
        //   label: CoreEnums.tabTitles.MEAL_PLANS,
        //   icon: <FontAwesomeIcon icon={faUtensils} style={{ color: CoreEnums.menuColors.CARE_PLANS }} />,
        //   visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
        // }
      ]
    },
    {
      key: CoreEnums.tabKeys.CARE_SYNC,
      label: CoreEnums.tabTitles.CARE_SYNC,
      icon: <FontAwesomeIcon icon={faKitMedical} style={{ color: CoreEnums.menuColors.CARE_SYNC }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN],
      children: [
        {
          key: CoreEnums.tabKeys.CARE_SYNC_LAB_TESTS,
          label: CoreEnums.tabTitles.CARE_SYNC_LAB_TESTS,
          icon: <FontAwesomeIcon icon={faKitMedical} style={{ color: CoreEnums.menuColors.CARE_SYNC_LAB_TESTS }} />,
          visibleTo: [CoreEnums.userRoles.SUPERADMIN]
        }
      ]
    },
    {
      key: CoreEnums.tabKeys.SEARCH_ENGINE,
      label: CoreEnums.tabTitles.SEARCH_ENGINE,
      icon: <FontAwesomeIcon icon={faKitMedical} style={{ color: CoreEnums.menuColors.MONITORING_PLANS }} />,
      visibleTo: [CoreEnums.userRoles.PATIENT]
    },
    {
      key: CoreEnums.tabKeys.MONITORING_PLANS,
      label: CoreEnums.tabTitles.MONITORING_PLANS,
      icon: <FontAwesomeIcon icon={faKitMedical} style={{ color: CoreEnums.menuColors.MONITORING_PLANS }} />,
      visibleTo: [CoreEnums.userRoles.MEDICAL_PROFESSIONAL]
    },
    {
      key: CoreEnums.tabKeys.GLOBAL_SERVICES,
      label: CoreEnums.tabTitles.GLOBAL_SERVICES,
      icon: <FontAwesomeIcon icon={faGlobe} style={{ color: CoreEnums.menuColors.GLOBAL_SERVICES }} />,
      visibleTo: [CoreEnums.userRoles.SUPERADMIN]
    },
    {
      key: 'prototype',
      label: 'Search Engine',
      icon: <FontAwesomeIcon icon={faGlobe} style={{ color: CoreEnums.menuColors.GLOBAL_SERVICES }} />,
      visibleTo: [CoreEnums.userRoles.ADMIN]
    }
  ]
}

export const rightMenuItems = [
  {
    key: CoreEnums.tabKeys.CLINICS,
    label: (
      <>
        <FontAwesomeIcon icon={faClinicMedical} style={{ width: 50 }} /> {CoreEnums.tabTitles.CLINICS}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.SERVICES,
    label: (
      <>
        <FontAwesomeIcon icon={faMortarBoard} style={{ width: 50 }} /> {CoreEnums.tabTitles.SERVICES}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.AVAILABILITY,
    label: (
      <>
        <FontAwesomeIcon icon={faCalendar} style={{ width: 50 }} /> {CoreEnums.tabTitles.AVAILABILITY}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.SYSTEM_USERS,
    label: (
      <>
        <FontAwesomeIcon icon={faUserGear} style={{ width: 50 }} /> {CoreEnums.tabTitles.SYSTEM_USERS}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.MEDICAL_PROFESSIONALS,
    label: (
      <>
        <FontAwesomeIcon icon={faUserDoctor} style={{ width: 50 }} /> {CoreEnums.tabTitles.MEDICAL_PROFESSIONALS}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.PATIENTS,
    label: (
      <>
        <FontAwesomeIcon icon={faUserGroup} style={{ width: 50 }} /> {CoreEnums.tabTitles.PATIENTS}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.BOOKINGS,
    label: (
      <>
        <FontAwesomeIcon icon={faBook} style={{ width: 50 }} /> {CoreEnums.tabTitles.BOOKINGS}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.CONFIG,
    label: (
      <>
        <FontAwesomeIcon icon={faCogs} style={{ width: 50 }} /> {CoreEnums.tabTitles.CONFIG}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.TERMS_AND_CONDITIONS,
    label: (
      <>
        <FontAwesomeIcon icon={faNewspaper} style={{ width: 50 }} /> {CoreEnums.tabTitles.TERMS_AND_CONDITIONS}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.AIMealTracker,
    label: (
      <>
        <FontAwesomeIcon icon={faNewspaper} style={{ width: 50 }} /> {CoreEnums.tabTitles.AIMealTracker}
      </>
    )
  },
  {
    key: CoreEnums.tabKeys.GLOBAL_SERVICES,
    label: (
      <>
        <FontAwesomeIcon icon={faGlobe} style={{ width: 50 }} /> {CoreEnums.tabTitles.GLOBAL_SERVICES}
      </>
    )
  }
]

export const generateContent = (key) => {
  window.scrollTo(0, 0)

  switch (key) {
    // Appointments Calendar
    case CoreEnums.tabKeys.APPOINTMENTS_CALENDAR:
      return {
        key,
        label: CoreEnums.tabTitles.APPOINTMENTS_CALENDAR,
        closable: false,
        children: <FullCalendarWrapper />
      }
    // Home
    case CoreEnums.tabKeys.HOME:
      return {
        key,
        label: CoreEnums.tabTitles.HOME,
        closable: false,
        children: <DashboardWrapper />
      }
    // Entities
    case CoreEnums.tabKeys.ENTITIES:
      return {
        key,
        label: CoreEnums.tabTitles.ENTITIES,
        closable: false,
        children: <EntityWrapper />
      }
    // Analytics - REMOVED: Replaced by Health Stats for patients
    // case CoreEnums.tabKeys.ANALYTICS:
    //   return {
    //     key,
    //     label: CoreEnums.tabTitles.ANALYTICS,
    //     closable: false,
    //     children: <AIWrapper />
    //   }
    // Admin Bookings
    case CoreEnums.tabKeys.BOOKINGS:
      return {
        key,
        label: CoreEnums.tabTitles.BOOKINGS,
        closable: true,
        children: <BookingsListView />
      }
    // Clinics
    case CoreEnums.tabKeys.CLINICS:
      return {
        key,
        label: CoreEnums.tabTitles.CLINICS,
        closable: true,
        children: <Clinics />
      }
    // Billing Profile
    case CoreEnums.tabKeys.BILLING_PROFILE:
      return {
        key,
        label: CoreEnums.tabTitles.BILLING_PROFILE,
        closable: true,
        children: <BillingProfile />
      }
    // Occupational health removed
    // Services
    case CoreEnums.tabKeys.SERVICES:
      return {
        key,
        label: CoreEnums.tabTitles.SERVICES,
        closable: true,
        children: <Services />
      }
    // Virtual Services
    case CoreEnums.tabKeys.VIRTUAL_SERVICES:
      return {
        key,
        label: CoreEnums.tabTitles.VIRTUAL_SERVICES,
        closable: true,
        children: <VirtualServicesWrapper />
      }
    // System Users
    case CoreEnums.tabKeys.SYSTEM_USERS:
      return {
        key,
        label: CoreEnums.tabTitles.SYSTEM_USERS,
        closable: true,
        children: <SystemUsers type='system' />
      }
    // Medical Professionals
    case CoreEnums.tabKeys.MEDICAL_PROFESSIONALS:
      return {
        key,
        label: CoreEnums.tabTitles.MEDICAL_PROFESSIONALS,
        closable: true,
        children: <SystemUsers type='medical' />
      }

    case CoreEnums.tabKeys.SEARCH_ENGINE:
      return {
        key,
        label: CoreEnums.tabTitles.SEARCH_ENGINE,
        closable: true,
        children: <SearchEngineWithProviders />
      }
    // Patients
    case CoreEnums.tabKeys.PATIENTS:
      return {
        key,
        label: CoreEnums.tabTitles.PATIENTS,
        closable: true,
        children: <SystemUsers type='patient' />
      }
    // Inventory case removed
    // Custom Diagnosis
    // case CoreEnums.tabKeys.CUSTOM_DIAGNOSIS:
    //   return {
    //     key,
    //     label: CoreEnums.tabTitles.CUSTOM_DIAGNOSIS,
    //     closable: true,
    //     children: <CustomDiagnosisWrapper />
    //   }
    // My Bookings
    case CoreEnums.tabKeys.MY_BOOKINGS:
      return {
        key,
        label: CoreEnums.tabTitles.MY_BOOKINGS,
        closable: true,
        children: <BookingsWrapper />
      }
    //AI Food Tool
    case CoreEnums.tabKeys.AIMealTracker:
      return {
        key,
        label: CoreEnums.tabTitles.AIMealTracker,
        closable: true,
        children: <AIWrapper />
      }
    // Scripts
    case CoreEnums.tabKeys.SCRIPTING:
      return {
        key,
        label: CoreEnums.tabTitles.SCRIPTING,
        closable: true,
        children: <ScriptsWrapper />
      }
    // Lab Orders
    case CoreEnums.tabKeys.LAB_ORDERS:
      return {
        key,
        label: CoreEnums.tabTitles.LAB_ORDERS,
        closable: true,
        children: <LabOrdersWrapper />
      }
    case CoreEnums.tabKeys.SCHEDULE_APPOINTMENT:
      return {
        key,
        label: CoreEnums.tabTitles.SCHEDULE_APPOINTMENT,
        closable: true,
        children: <NewBooking isReceptionBooking={true} />
      }
    //Schedule Clinic Visit
    case CoreEnums.tabKeys.SCHEDULE_CLINIC_VISIT:
      return {
        key,
        label: CoreEnums.tabTitles.SCHEDULE_CLINIC_VISIT,
        closable: true,
        children: <NewBooking />
      }
    //Schedule Virtual Visit
    case CoreEnums.tabKeys.SCHEDULE_VIRTUAL_VISIT:
      return {
        key,
        label: CoreEnums.tabTitles.SCHEDULE_VIRTUAL_VISIT,
        closable: true,
        children: <MobVirtualBookingWrapper />
      }
    // Billing
    case CoreEnums.tabKeys.BILLING:
      return {
        key,
        label: CoreEnums.tabTitles.BILLING,
        closable: true,
        children: <BookingsWrapper isBilling />
      }
    // Invoices
    case CoreEnums.tabKeys.INVOICES:
      return {
        key,
        label: CoreEnums.tabTitles.INVOICES,
        closable: true,
        children: <InvoicesList />
      }
    // Medical Aid Payments
    case CoreEnums.tabKeys.REMITTANCES:
      return {
        key,
        label: CoreEnums.tabTitles.REMITTANCES,
        closable: true,
        children: <MedicalAidPaymentList />
      }
    // Enhanced Billing Module
    case CoreEnums.tabKeys.PATIENT_ACCOUNTS:
      return {
        key,
        label: CoreEnums.tabTitles.PATIENT_ACCOUNTS,
        closable: true,
        children: <BillingModuleEnhanced />
      }
    // My Appointments
    case CoreEnums.tabKeys.MY_APPOINTMENTS:
      return {
        key,
        label: CoreEnums.tabTitles.MY_APPOINTMENTS,
        closable: true,
        children: <BookingsWrapper />
      }

    // User
    case CoreEnums.tabKeys.PERSONAL_DETAILS:
      return {
        key,
        label: CoreEnums.tabTitles.PERSONAL_DETAILS,
        closable: true,
        children: <Profile />
      }
    case CoreEnums.tabKeys.SUBSCRIPTIONS:
      return {
        key,
        label: CoreEnums.tabTitles.SUBSCRIPTIONS,
        closable: true,
        children: <SubscriptionsList />
      }
    case CoreEnums.tabKeys.MEDICAL_HISTORY:
      return {
        key,
        label: CoreEnums.tabTitles.MEDICAL_HISTORY,
        closable: true,
        children: <PatMedHist />
      }
    case CoreEnums.tabKeys.NEW_MEDICAL_HISTORY:
      return {
        key,
        label: CoreEnums.tabTitles.NEW_MEDICAL_HISTORY, // This will now show "Shaun Proto"
        closable: true,
        children: <DesktopMedicalHistoryWrapper isPatient />
      }
    // My Patient File
    case CoreEnums.tabKeys.MY_PATIENT_FILE:
      return {
        key,
        label: CoreEnums.tabTitles.MY_PATIENT_FILE,
        closable: true,
        children: <PatientFileLanding />
      }

    // Terms and Conditions
    case CoreEnums.tabKeys.TERMS_AND_CONDITIONS:
      return {
        key,
        label: CoreEnums.tabTitles.TERMS_AND_CONDITIONS,
        closable: true,
        children: <TermsConditionsWrapper />
      }
    // Dependants
    case CoreEnums.tabKeys.DEPENDANTS:
      return {
        key,
        label: CoreEnums.tabTitles.DEPENDANTS,
        closable: true,
        children: <Dependants />
      }
    // Management
    case CoreEnums.tabKeys.MANAGEMENT:
      return {
        key,
        label: CoreEnums.tabTitles.MANAGEMENT,
        closable: true,
        children: <AvailabilityWrapper isManager={true} />
      }
    // Availability
    case CoreEnums.tabKeys.AVAILABILITY:
      return {
        key,
        label: CoreEnums.tabTitles.AVAILABILITY,
        closable: true,
        children: <AvailabilityWrapper />
      }
    // Config
    case 'config':
      return {
        key,
        label: 'Settings',
        closable: true,
        children: <Config />
      }
    // Booking Form
    case 'patient_examination_form':
      return {
        key,
        label: 'Patient Examination',
        closable: true,
        children: <PatientExaminationForm />
      }
    // Health Tracking Entries
    case CoreEnums.tabKeys.HEALTH_TRACKING_ENTRIES:
      return {
        key,
        label: CoreEnums.tabTitles.HEALTH_TRACKING_ENTRIES,
        closable: true,
        children: <HealthTrackingEntriesView />
      }
    // Vital Link
    // case CoreEnums.tabKeys.VITAL_LINK:
    //   return {
    //     key,
    //     label: CoreEnums.tabTitles.VITAL_LINK,
    //     closable: true,
    //     children: <VitalLink />
    //   }
    case CoreEnums.tabKeys.ADMIN_SUBSCRIPTIONS:
      return {
        key,
        label: CoreEnums.tabTitles.ADMIN_SUBSCRIPTIONS,
        closable: true,
        children: <AdminSubscriptionsList />
      }
    // CRM case removed

    case CoreEnums.tabKeys.DATA_POINTS_STANDARD:
      return {
        key,
        label: CoreEnums.tabTitles.DATA_POINTS_STANDARD,
        closable: true,
        children: <DataPointsWrapper type='standard' />
      }
    case CoreEnums.tabKeys.DATA_POINTS_VITALS:
      return {
        key,
        label: CoreEnums.tabTitles.DATA_POINTS_VITALS,
        closable: true,
        children: <DataPointsWrapper type='vitals' />
      }
    case CoreEnums.tabKeys.DATA_POINTS_RAPID:
      return {
        key,
        label: CoreEnums.tabTitles.DATA_POINTS_RAPID,
        closable: true,
        children: <DataPointsWrapper type='rapid' />
      }
    case CoreEnums.tabKeys.DATA_POINTS_GENERAL:
      return {
        key,
        label: CoreEnums.tabTitles.DATA_POINTS_POC,
        closable: true,
        children: <DataPointsWrapper type='general' />
      }
    case CoreEnums.tabKeys.DATA_POINTS_POC:
      return {
        key,
        label: CoreEnums.tabTitles.DATA_POINTS_POC,
        closable: true,
        children: <DataPointsWrapper type='poc' />
      }
    case CoreEnums.tabKeys.DATA_POINTS_LAB:
      return {
        key,
        label: CoreEnums.tabTitles.LAB_DATA_POINTS,
        closable: true,
        children: <DataPointsWrapper type='lab' />
      }
    case CoreEnums.tabKeys.CLINICAL_REPORTING_TEMPLATES:
      return {
        key,
        label: CoreEnums.tabTitles.CLINICAL_REPORTING_TEMPLATES,
        closable: true,
        children: <ClinicalReportingTemplatesWrapper />
      }

    case CoreEnums.tabKeys.CLINICAL_ANALYTICS:
      return {
        key,
        label: CoreEnums.tabTitles.CLINICAL_ANALYTICS,
        closable: true,
        children: <ClinicalAnalytics />
      }
    case CoreEnums.tabKeys.CARE_PLANS:
      return {
        key,
        label: CoreEnums.tabTitles.CARE_PLANS,
        closable: true,
        children: <CarePlansWrapper />
      }
    case CoreEnums.tabKeys.TREATMENT_PLANS:
      return {
        key,
        label: CoreEnums.tabTitles.TREATMENT_PLANS,
        closable: true,
        children: <TreatmentPlansWrapper />
      }
    case CoreEnums.tabKeys.PREVENTATIVE_PLANS:
      return {
        key,
        label: CoreEnums.tabTitles.PREVENTATIVE_PLANS,
        closable: true,
        children: <PreventivePlansWrapper />
      }
    case CoreEnums.tabKeys.REHABILITATION_PLANS:
      return {
        key,
        label: CoreEnums.tabTitles.REHABILITATION_PLANS,
        closable: true,
        children: <RehabilitationPlansWrapper />
      }
    case CoreEnums.tabKeys.WELLNESS_PLANS:
      return {
        key,
        label: CoreEnums.tabTitles.WELLNESS_PLANS,
        closable: true,
        children: <WellnessPlansWrapper />
      }
    case CoreEnums.tabKeys.MEAL_PLANS:
      return {
        key,
        label: CoreEnums.tabTitles.MEAL_PLANS,
        closable: true,
        children: <MealPlansWrapper />
      }
    case CoreEnums.tabKeys.MONITORING_PLANS:
      return {
        key,
        label: CoreEnums.tabTitles.MONITORING_PLANS,
        closable: true,
        children: <CarePlansWrapper isMonitoring />
      }
    case CoreEnums.tabKeys.PEACH_PAYMENTS_TEMPORARY:
      return {
        key,
        label: CoreEnums.tabTitles.PEACH_PAYMENTS_TEMPORARY,
        closable: true,
        children: <PeachPaymentsWrapper />
      }
    case CoreEnums.tabKeys.CARE_SYNC_LAB_TESTS:
      return {
        key,
        label: CoreEnums.tabTitles.CARE_SYNC_LAB_TESTS,
        closable: true,
        children: <CareSyncLabTestsListView />
      }
    case CoreEnums.tabKeys.DASHBOARD_BILLING:
      return {
        key,
        label: CoreEnums.tabTitles.DASHBOARD_BILLING,
        closable: true,
        children: <BillingDashboard />
      }
    case 'inventory_dashboard':
      return {
        key,
        label: 'Inventory Dashboard',
        closable: true,
        children: <InventoryDashboard />
      }
    case 'inventory_items':
      return {
        key,
        label: 'Inventory Items',
        closable: true,
        children: <InventoryList />
      }
    case 'purchase_orders':
      return {
        key,
        label: 'Purchase Orders',
        closable: true,
        children: <PurchaseOrders />
      }
    case 'inventory_reports':
      return {
        key,
        label: 'Inventory Reports & Analytics',
        closable: true,
        children: <InventoryReports />
      }
    case 'hospital_dashboard':
      return {
        key,
        label: 'Hospital Dashboard',
        closable: true,
        children: <HospitalDashboard />
      }
    case 'admissions':
      return {
        key,
        label: 'Admissions',
        closable: true,
        children: <Admissions />
      }
    case 'bed_management':
      return {
        key,
        label: 'Bed Management',
        closable: true,
        children: <BedManagement />
      }
    case 'patient_care_tasks':
      return {
        key,
        label: 'Patient Care Tasks',
        closable: true,
        children: <PatientCareTasks />
      }
    case 'caregiver_activities':
      return {
        key,
        label: 'Caregiver Activities',
        closable: true,
        children: <CaregiverActivities />
      }
    case 'staff_reminders':
      return {
        key,
        label: 'Staff Reminders',
        closable: true,
        children: <StaffReminders />
      }
    case 'theatre_dashboard':
      return {
        key,
        label: 'Theatre Dashboard',
        closable: true,
        children: <TheatreDashboard />
      }
    case 'discharge_instructions':
      return {
        key,
        label: 'Discharge Instructions',
        closable: true,
        children: <DischargeInstructions />
      }
    case 'surgery_list':
      return {
        key,
        label: 'Surgery List',
        closable: true,
        children: <SurgeryList />
      }
    case 'theatre_room_events':
      return {
        key,
        label: 'Theatre Room Events',
        closable: true,
        children: <TheatreRoomEvents />
      }
    case CoreEnums.tabKeys.PAT_CARE_SYNC:
      return {
        key,
        label: CoreEnums.tabTitles.PAT_CARE_SYNC,
        closable: true,
        children: <PatCareSync />
      }
    case CoreEnums.tabKeys.PAT_HEALTH_STATS:
      return {
        key,
        label: CoreEnums.tabTitles.PAT_HEALTH_STATS,
        closable: true,
        children: <MobHealthStatsWrapper />
      }
    case CoreEnums.tabKeys.PAT_PATIENT_PROFILE:
      return {
        key,
        label: CoreEnums.tabTitles.PAT_PATIENT_PROFILE,
        closable: true,
        children: <PatProfile />
      }
    case CoreEnums.tabKeys.GLOBAL_SERVICES:
      return {
        key,
        label: CoreEnums.tabTitles.GLOBAL_SERVICES,
        closable: true,
        children: <GlobalServicesWrapper />
      }
    case 'prototype':
      return {
        key,
        label: 'Search Engine',
        closable: true,
        children: <SearchEngine />
      }
    default:
      return {
        key,
        label: 'NOT FOUND',
        closable: true,
        children: (
          <center>
            <h1>This tab does not exist</h1>
          </center>
        )
      }
  }
}

export const initCustomReducers = () => {
  return {
    // Patient
    patMedHist: patMedHistReducer.reducer,
    patHealthStats: patHealthStatsReducer.reducer,
    patAppointments: patAppointmentsReducer.reducer,
    patMacroTracker: patMacroTrackerReducer.reducer,
    careSyncTests: careSyncTestsReducer.reducer,
    careSyncTestResults: careSyncTestResultsReducer.reducer,
    careSyncDataPoints: careSyncDataPointsReducer.reducer,

    // Authentication && User State
    core: coreReducer.reducer,
    auth: AuthReducer.reducer,
    subscriptions: SubscriptionsReducer.reducer,
    adminSubscriptions: AdminSubscriptionsReducer.reducer,

    // TODO: To be removed
    medicalProfessionals: MedicalProfessionalReducer.reducer,
    patients: PatientsReducer.reducer,

    // Assessment
    examTemplates: ExamTemplatesReducer.reducer,
    dataPoints: DataPointsReducer.reducer,

    // Configuration
    entities: EntitiesReducer.reducer,
    clinics: ClinicsReducer.reducer,
    services: ServicesReducer.reducer,
    virtualServices: virtualServicesReducer.reducer,

    // Users
    systemUsers: SystemUsersReducer.reducer,

    // Bookings
    bookings: BookingsReducer.reducer,
    adminBookings: AdminBookingsReducer.reducer,
    todaysPatients: TodaysPatientsReducer.reducer,
    employeeBookings: EmployeeBookingsReducer.reducer,
    billing: BillingReducer.reducer,
    dependents: DependentsReducer.reducer,
    appointmentsCalendar: AppointmentsCalendarReducer.reducer,

    // Admin\
    availability: availabilityReducer.reducer,

    // Search Engine
    searchEngine: searchEngineReducer.reducer,
    searchEngineBooking: searchEngineBookingReducer.reducer
  }
}
